import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import * as React from 'react';

var IcAdd24Px = function IcAdd24Px(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
  }));
};

export default IcAdd24Px;